import { render, staticRenderFns } from "./tradeForm.vue?vue&type=template&id=4da0e1ce&scoped=true"
import script from "./tradeForm.vue?vue&type=script&lang=js"
export * from "./tradeForm.vue?vue&type=script&lang=js"
import style0 from "./tradeForm.vue?vue&type=style&index=0&id=4da0e1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0e1ce",
  null
  
)

export default component.exports